import { PrismicRichText } from '@prismicio/react';
import { isBrowser } from '@publicss/utils';
import cx from 'classnames';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import Cookies from 'js-cookie';
import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import validator from 'validator/es';

import { media } from '../../../styles/media';
import { Button } from '../../ui';
import { getUTMParam, getGCLIDParam } from '../contactFormUtil';
import { getCurrURL, getLeadTag, getURLWithLang } from './contactForm.util';

const Section = styled.section`
  .iti__selected-flag {
    padding: 0;
  }
  .country--holder {
    display: flex;
    align-items: flex-end;
    padding: 0 0 26px;
    @media ${media.lgUp} {
      padding: 0 0 45px;
    }
  }
  .country-select {
    display: none;
  }
  .iti__selected-dial-code {
    color: var(--grey-4);
  }
  .secondary {
    .iti__arrow {
      border-inline-start: 3px solid transparent;
      border-inline-end: 3px solid transparent;
      border-top: 4px solid var(--white);
      &.iti__arrow--up {
        border-top: none;
        border-bottom: 4px solid var(--white);
      }
    }
    .country-select {
      background: var(--accent-1);
    }
    .iti__selected-dial-code {
      color: var(--white);
    }
  }
  .iti--allow-dropdown {
    width: 85px;
  }
  .iti__selected-dial-code {
    font-weight: 500;
  }
  .iti__country-list {
    margin-top: 15px;
  }
`;

const locations = {
  'smartcity-kitchens': [
    { value: 'Tampines', label: 'Tampines' },
    { value: 'Clementi', label: 'Clementi' },
    { value: 'Sembawang', label: 'Sembawang' },
    { value: 'Orchard', label: 'Orchard' },
    { value: 'Bishan', label: 'Bishan' },
    { value: 'Serangoon North', label: 'Serangoon North' },
    { value: 'Bedok', label: 'Bedok' },
    { value: 'Bukit Batok', label: 'Bukit Batok' },
    { value: 'MacPherson', label: 'MacPherson' },
  ],
  kitchenbase: [],
  kitchenvalley: [],
  kitchenplus: [
    {
      value: 'Udyog Vihar, Delhi (NCR)',
      label: 'Udyog Vihar, Delhi (NCR)',
    },
    {
      value: 'Rajouri Garden, Delhi (NCR)',
      label: 'Rajouri Garden, Delhi (NCR)',
    },
    {
      value: 'Noida Sector 4, Delhi (NCR)',
      label: 'Noida Sector 4, Delhi (NCR)',
    },
    {
      value: 'GTB Nagar, Delhi (NCR)',
      label: 'GTB Nagar, Delhi (NCR)',
    },
    { value: 'Powai, Mumbai', label: 'Powai, Mumbai' },
    {
      value: 'Whitefield, Bengaluru',
      label: 'Whitefield, Bengaluru',
    },
  ],
  kitchenconnect: [
    {
      value: 'Bangsar, Kuala Lumpur',
      label: 'Bangsar, Kuala Lumpur',
    },
    {
      value: 'KL City Center, Kuala Lumpur',
      label: 'KL City Center, Kuala Lumpur',
    },
    {
      value: 'Damansara Jaya, Kuala Lumpur',
      label: 'Damansara Jaya, Kuala Lumpur',
    },
  ],
  chefcollective: [
    {
      value: 'Cambridge Street, Brisbane',
      label: 'Cambridge Street, Brisbane',
    },
    {
      value: 'Arden Street, Melbourne',
      label: 'Arden Street, Melbourne',
    },
  ],
  kitchennow: [
    { value: 'Xin Yi, Taipei', label: '台北市 信義區' },
    { value: 'Neihu, Taipei', label: '台北市 內湖區' },
    { value: 'Ximen, Taipei', label: '台北市 西門區' },
    { value: 'Datong, Taipei', label: '台北市 大同區' },
    { value: 'Zhonghe, Taipei', label: '新北市 中和區' },
  ],
  everplate: [
    { value: 'Kemang, Jakarta', label: 'Kemang, Jakarta' },
    { value: 'Slipi, Jakarta', label: 'Slipi, Jakarta' },
    {
      value: 'Belmont Residence, Jakarta',
      label: 'Belmont Residence, Jakarta',
    },
    {
      value: 'Kelapa Gading, Jakarta',
      label: 'Kelapa Gading, Jakarta',
    },
    {
      value: 'Pasar Baru, Jakarta',
      label: 'Pasar Baru, Jakarta',
    },
    { value: 'Senen, Jakarta', label: 'Senen, Jakarta' },
    {
      value: 'Permata Hijau, Jakarta',
      label: 'Permata Hijau, Jakarta',
    },
    {
      value: 'Sudirman, Jakarta',
      label: 'Sudirman, Jakarta',
    },
  ],
  'freshlane-en': [
    {
      value: 'Sai Ying Pun',
      label: 'Sai Ying Pun',
    },
    {
      value: 'Wan Chai',
      label: 'Wan Chai',
    },
    {
      value: 'North Point',
      label: 'North Point',
    },
    {
      value: 'Mong Kok',
      label: 'Mong Kok',
    },
  ],
  'freshlane-zh': [
    {
      value: 'Sai Ying Pun',
      label: '西營盤',
    },
    {
      value: 'Wan Chai',
      label: '灣仔',
    },
    {
      value: 'North Point',
      label: '北角',
    },
    {
      value: 'Mong Kok',
      label: '旺角',
    },
  ],
};

class ContactForm extends Component {
  componentDidMount() {
    const { prefixId, countryCode } = this.props;

    // Flag + Country picker scripts
    window.intlTelInput = intlTelInput;
    const input = document.querySelector(`.${prefixId}-country-select`);
    window.intlTelInput(input, {
      initialCountry: countryCode,
      separateDialCode: true,
      onlyCountries: ['sg', 'my', 'au', 'id', 'in', 'tw', 'hk', 'jp', 'kr'],
    });
  }

  inputFocus = (e) => {
    const { id } = e.currentTarget.dataset;
    const { parentId } = this.props;
    const parent = document.querySelector(
      `${parentId} .form--element[data-id=${id}]`
    );

    parent.classList.add('focus');
  };

  inputType = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }

    const current = e.currentTarget;
    const text = current.innerHTML;
    const { id } = current.dataset;
    const { parentId } = this.props;
    const parent = document.querySelector(
      `${parentId} .form--element[data-id=${id}]`
    );
    const border = document.querySelector(
      `${parentId} .form--element--border[data-id=${id}]`
    );

    if (text) {
      parent.classList.remove('done');
      parent.classList.add('active');
      const width = current.clientWidth;
      border.style.width = `${width + 24}px`;
    } else {
      parent.classList.remove('active');
      border.style.width = '0px';
    }
  };

  // TODO: REMOVE All DOM Manipulation
  required = ($type, $name) => {
    const { parentId, translate: t } = this.props;
    const holder = document.querySelector(
      `${parentId} .form--element[data-id="${$type}"]`
    );
    const label = document.querySelector(
      `${parentId} .form--element[data-id="${$type}"] .form--element--label`
    );

    holder.classList.add('focus');
    holder.classList.add('error');

    label.innerHTML = `${t($name)} ${t('is_required')}`;
  };

  // TODO: REMOVE All DOM Manipulation
  resetLabel = ($type, $name) => {
    const { parentId, translate: t } = this.props;
    const holder = document.querySelector(
      `${parentId} .form--element[data-id="${$type}"]`
    );
    const label = document.querySelector(
      `${parentId} .form--element[data-id="${$type}"] .form--element--label`
    );

    holder.classList.remove('error');
    label.innerHTML = t($name);
  };

  phoneValidation = () => {
    const { prefixId, phone, translate: t } = this.props;
    const dialNum = document.querySelector(
      `.country--holder[data-id=${prefixId}-country] .iti__selected-dial-code`
    );
    const dialCode = dialNum.innerText;
    const phoneIsRequired = `${t('phone')} ${t('is_required')}`;

    if (!phone.length) return phoneIsRequired;

    const num = phone?.toString().replace(/\D+/g, '');
    const numLength = num.length;

    // Singapore and Hong Kong, 8 digits
    if (dialCode === '+65' || dialCode === '+852') {
      if (numLength === 8) return 'success';
      if (numLength <= 0) return phoneIsRequired;

      return `8 ${t('digits')}`;
    }

    // Taiwan, 9-10 digits
    if (dialCode === '+886') {
      if (numLength === 9 || numLength === 10) return 'success';
      if (numLength <= 0) return phoneIsRequired;

      return `9-10 ${t('digits')}`;
    }

    // Malaysia, 10-11 digits
    if (dialCode === '+60') {
      if (numLength === 10 || numLength === 11) return 'success';
      if (numLength <= 0) return phoneIsRequired;

      return `10-11 ${t('digits')}`;
    }

    // Indonesia, 13 digits
    if (dialCode === '+62') {
      if (numLength === 13) return 'success';
      if (numLength <= 0) return phoneIsRequired;

      return `13 ${t('digits')}`;
    }

    // Australia, India, Japan, South Korea, 10 digits
    if (numLength === 10) return 'success';
    if (numLength <= 0) return phoneIsRequired;
    return `10 ${t('digits')}`;
  };

  form1Click = (e) => {
    if (e) e.preventDefault();

    const {
      lastName,
      company,
      email,
      locations,
      phone,
      orders,
      prefixId,
      parentId,
    } = this.props;

    const { utmSource, utmCampaign, utmMedium, utmTerm, utmContent } =
      getUTMParam();
    const { gclid } = getGCLIDParam();
    const leadSource = getLeadTag(utmSource, utmMedium, getCurrURL());
    const currentURL = ['Inbound: Website', 'Inbound: Blog'].includes(
      leadSource
    )
      ? getCurrURL()
      : '';
    const { translate: t, siteTag } = this.props;
    const postUrl =
      'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';
    const dialNum = document
      .querySelector(
        `.country--holder[data-id=${prefixId}-country] .iti__selected-dial-code`
      )
      .innerText.trim();
    const phoneValidationResult = this.phoneValidation();
    const accept =
      document.querySelector(`#${prefixId}-accept-terms:checked`) !== null;
    const acceptLabel = document.querySelector(
      `.${prefixId}-form--element--terms`
    );
    const ueidHp = isBrowser() ? Cookies.get('ueid_hp') : null;

    if (!validator.isLength(lastName, { min: 1, max: undefined })) {
      this.required(`${prefixId}-last-name`, 'full_name');
      return false;
    }
    this.resetLabel(`${prefixId}-last-name`, 'full_name');

    if (phoneValidationResult !== 'success') {
      const holder = document.querySelector(
        `${parentId} .form--element[data-id="${prefixId}-phone"]`
      );
      const label = document.querySelector(
        `${parentId} .form--element[data-id="${prefixId}-phone"] .form--element--label`
      );

      holder.classList.add('focus');
      holder.classList.add('error');

      label.innerHTML = phoneValidationResult;

      return false;
    }

    this.resetLabel(`${prefixId}-phone`, 'contact_number');

    if (!validator.isLength(company, { min: 1, max: undefined })) {
      this.required(`${prefixId}-company`, 'company_name');

      return false;
    }
    this.resetLabel(`${prefixId}-company`, 'company_name');

    if (!validator.isEmail(email)) {
      this.required(`${prefixId}-email`, 'email');

      return false;
    }
    this.resetLabel(`${prefixId}-email`, 'email');

    if (
      !validator.isLength(locations, {
        min: 1,
        max: undefined,
      })
    ) {
      this.required(`${prefixId}-locations`, 'preferred_locations');

      return false;
    }
    this.resetLabel(`${prefixId}-locations`, 'preferred_locations');

    if (!accept) {
      acceptLabel.classList.add('error');

      return false;
    }
    acceptLabel.classList.remove('error');

    const isEverbuzzPage =
      siteTag === 'everplate' && getCurrURL()?.includes('marketing-services');

    const body = {
      oid: '00Df4000003jvM8',
      '00Nf400000UWoqU': t(`kitchen_country_${siteTag}`), // Kitchen Country
      '00Nf400000Nk64e': this.getCityFromLocation(siteTag, locations), // Kitchen City
      '00N5G00000VKzbd': locations,
      '00N5G00000V8EjA': utmSource,
      '00N5G00000V8Ej7': utmCampaign,
      '00N5G00000V8Ej9': utmMedium,
      '00N5G00000V8EjB': utmTerm,
      '00N5G00000V8Ej8': utmContent,
      '00N5G00000VKzUr': gclid,
      '00Nf400000UmSJ9': ueidHp,
      lead_source: leadSource,
      last_name: lastName,
      phone: `${dialNum} ${phone.trim()}`,
      company,
      email,
      GCLID__c: gclid,
      Landing_Page_URL__c: currentURL,
      Kitchen_Type__c: isEverbuzzPage ? 'Virtual' : 'Delivery',
      Daily_Delivery_Order_Volume__c: orders,
      // debug: 1,
      // debugEmail: 'jesse.goodnoe@cloudkitchens.com',
    };

    const encode = (data) =>
      Object.keys(data)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&');

    fetch(postUrl, {
      method: 'post',
      mode: 'no-cors',
      body: encode(body),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then(() => {
        const form1 = document.querySelector(`${parentId} .form-1`);
        const form2 = document.querySelector(`${parentId} .form-2`);
        form1.classList.remove('is-active');
        form2.classList.add('is-active');

        if (parentId === '#modal--contact') {
          const modal = document.getElementById('modal--contact');
          modal.scrollTo(0, 0);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'formSubmit',
          form_step: 'success',
        });
      })
      .catch((error) => console.error('Error:', error));
  };

  radioLabel = () => {
    const { parentId, stateHandler } = this.props;
    const label = document.querySelector('.label--radio');
    let valueString = '';

    label.classList.remove('color--grey-4');
    label.classList.add('color--grey-6');
    const valuesArray = document.querySelectorAll(
      `${parentId} input[name="orders[]"]:checked`
    );

    for (const checkbox of valuesArray) {
      valueString += `${checkbox.value};`;
    }
    stateHandler({ orders: valueString.slice(0, -1) });
  };

  inputReset = (e) => {
    const current = e.currentTarget;
    const text = current.innerHTML;
    const { id } = current.dataset;
    const { parentId } = this.props;

    const parent = document.querySelector(
      `${parentId}  .form--element[data-id=${id}]`
    );
    const border = document.querySelector(
      `${parentId}  .form--element--border[data-id=${id}]`
    );
    if (!text) {
      parent.classList.remove('done');
      parent.classList.remove('focus');
      parent.classList.remove('active');
      border.style.width = '0px';
    } else {
      parent.classList.add('done');
    }
  };

  handlePreferredLocationsChange = (preferredLocationsValue) => {
    const { parentId, stateHandler } = this.props;

    const element = document.querySelector(
      `${parentId}  .form--element--preferred-locations`
    );
    if (preferredLocationsValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    stateHandler({ locations: preferredLocationsValue.value });
  };

  getCityFromLocation = (siteTag, location) => {
    switch (siteTag) {
      case 'smartcity-kitchens':
        return 'Singapore';

      case 'kitchenplus':
        return location.split(', ')[1].replace(' (NCR)', '');

      case 'kitchenconnect':
        return location.split(', ')[1];

      case 'chefcollective':
        return location.split(', ')[1];

      case 'kitchennow':
        return location.split(', ')[1];

      case 'everplate':
        return location.split(', ')[1];

      case 'freshlane':
        return 'Hong Kong';

      default:
        break;
    }
  };

  render() {
    const { translate: t, siteTag, langKey } = this.props;

    let formElementClassName = 'form--element';
    let labelClassName = 'form--element--label';
    let textClassName = 'form--element--text';
    let placeholderClassName = 'form--element--placeholder';
    let borderClassName = 'form--element--border';
    let formHeaderClassName = 'sm:mt-6 md:mt-0 lg:mb-3 lg:mt-0 color--grey-6';

    // if (this.props.parentId === '#block-hero-form') {
    if (this.props.color === 'white') {
      formElementClassName = 'form--element secondary';
      labelClassName = 'form--element--label color--white';
      textClassName = 'form--element--text color--white';
      placeholderClassName = 'form--element--placeholder secondary';
      borderClassName = 'form--element--border color--white';
      formHeaderClassName = 'lg:mb-3 color--white';
    }
    return (
      <>
        <Section>
          <div className={cx('form-1 is-active')}>
            {this.props.header?.richText?.length > 0 && (
              <div className={formHeaderClassName}>
                <PrismicRichText field={this.props.header.richText} />
              </div>
            )}

            <div
              className={formElementClassName}
              data-id={`${this.props.prefixId}-last-name`}>
              <label className={labelClassName}>{t('full_name')}</label>

              <div
                className={textClassName}
                contentEditable="true"
                spellCheck="false"
                data-id={`${this.props.prefixId}-last-name`}
                onFocus={this.inputFocus}
                onKeyDown={this.inputType}
                onBlur={this.inputReset}
                onKeyUp={(e) =>
                  this.props.stateHandler({
                    lastName: e.target.innerText.trim(),
                  })
                }
              />
              <div className={placeholderClassName}>{t('full_name')}</div>

              <div
                className={borderClassName}
                data-id={`${this.props.prefixId}-last-name`}
              />
            </div>
            <div className="flex">
              <div
                className={`country--${formElementClassName} country--holder`}
                data-id={`${this.props.prefixId}-country`}>
                <input
                  className={`${this.props.prefixId}-country-select country-select`}
                />
              </div>
              <div
                className={formElementClassName}
                data-id={`${this.props.prefixId}-phone`}>
                <label className={labelClassName}>{t('contact_number')}</label>
                <div
                  className={textClassName}
                  contentEditable="true"
                  spellCheck="false"
                  data-id={`${this.props.prefixId}-phone`}
                  onFocus={this.inputFocus}
                  onKeyDown={this.inputType}
                  onBlur={this.inputReset}
                  onKeyUp={(e) => {
                    this.props.stateHandler({
                      phone: e.target.innerText.trim(),
                    });
                  }}
                />
                <div className={placeholderClassName}>
                  {t('contact_number')}
                </div>
                <div
                  className={borderClassName}
                  data-id={`${this.props.prefixId}-phone`}
                />
              </div>
            </div>

            <div
              className={formElementClassName}
              data-id={`${this.props.prefixId}-company`}>
              <label className={labelClassName}>{t('company')}</label>
              <div
                className={textClassName}
                contentEditable="true"
                spellCheck="false"
                data-id={`${this.props.prefixId}-company`}
                onFocus={this.inputFocus}
                onKeyDown={this.inputType}
                onBlur={this.inputReset}
                onKeyUp={(e) => {
                  this.props.stateHandler({
                    company: e.target.innerText.trim(),
                  });
                }}
              />
              <div className={placeholderClassName}>{t('company_name')}</div>
              <div
                className={borderClassName}
                data-id={`${this.props.prefixId}-company`}
              />
            </div>

            <div
              className={formElementClassName}
              data-id={`${this.props.prefixId}-email`}>
              <label className={labelClassName}>{t('email')}</label>
              <div
                className={textClassName}
                contentEditable="true"
                spellCheck="false"
                data-id={`${this.props.prefixId}-email`}
                onFocus={this.inputFocus}
                onKeyDown={this.inputType}
                onBlur={this.inputReset}
                onKeyUp={(e) => {
                  this.props.stateHandler({ email: e.target.innerText.trim() });
                }}
              />
              <div className={placeholderClassName}>{t('email')}</div>
              <div
                className={borderClassName}
                data-id={`${this.props.prefixId}-email`}
              />
            </div>

            {siteTag !== 'chefcollective' && (
              <div className="mt-10">
                <p
                  className={cx(
                    'normal label--radio mb-5 mt-5',
                    // this.props.parentId === '#block-hero-form'
                    this.props.color === 'white'
                      ? 'h4 color--white'
                      : 'color--grey-4 form--element--placeholder'
                  )}>
                  {t('estimated_daily_orders')}
                </p>
                <div
                  className={cx(
                    'grid grid-cols-1 gap-y-4 md:grid-cols-2',
                    // this.props.parentId === '#block-hero-form'
                    this.props.color === 'white'
                      ? 'secondary'
                      : 'lg:grid-cols-3'
                  )}>
                  <div>
                    <input
                      id={`${this.props.prefixId}-r1`}
                      type="radio"
                      name="orders[]"
                      value="0"
                      onChange={this.radioLabel}
                    />
                    <label htmlFor={`${this.props.prefixId}-r1`}>
                      0 {t('orders')}
                    </label>
                  </div>
                  <div>
                    <input
                      id={`${this.props.prefixId}-r2`}
                      type="radio"
                      name="orders[]"
                      value="1-10"
                      onChange={this.radioLabel}
                    />
                    <label htmlFor={`${this.props.prefixId}-r2`}>
                      1-10 {t('orders')}
                    </label>
                  </div>
                  <div>
                    <input
                      id={`${this.props.prefixId}-r3`}
                      type="radio"
                      name="orders[]"
                      value="10-20"
                      onChange={this.radioLabel}
                    />
                    <label htmlFor={`${this.props.prefixId}-r3`}>
                      10-20 {t('orders')}
                    </label>
                  </div>
                  <div>
                    <input
                      id={`${this.props.prefixId}-r4`}
                      type="radio"
                      name="orders[]"
                      value="20-50"
                      onChange={this.radioLabel}
                    />
                    <label htmlFor={`${this.props.prefixId}-r4`}>
                      20-50 {t('orders')}
                    </label>
                  </div>
                  <div>
                    <input
                      id={`${this.props.prefixId}-r5`}
                      type="radio"
                      name="orders[]"
                      value="50+"
                      onChange={this.radioLabel}
                    />
                    <label htmlFor={`${this.props.prefixId}-r5`}>
                      50+ {t('orders')}
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div
              className="form--element form--element--preferred-locations my-5"
              data-id={`${this.props.prefixId}-locations`}>
              <label className={labelClassName}>
                {t('preferred_locations')}
              </label>
              <Select
                className="form--element--select"
                classNamePrefix="react-select"
                id={`${this.props.prefixId}-preferredLocation`}
                name="locations"
                placeholder={t('preferred_locations')}
                isSearchable={false}
                isClearable={false}
                cache={false}
                onChange={this.handlePreferredLocationsChange}
                options={
                  siteTag === 'freshlane'
                    ? [...locations[`${siteTag}-${langKey}`]]
                    : [...locations[`${siteTag}`]]
                }
              />
            </div>

            <div
              className={`form--element--terms ${this.props.prefixId}-form--element--terms relative mt-8`}>
              <input
                style={{ position: 'absolute' }}
                className="left-0 top-0"
                id={`${this.props.prefixId}-accept-terms`}
                type="checkbox"
                name="accept-terms"
                value="true"
              />
              <label
                htmlFor={`${this.props.prefixId}-accept-terms`}
                className={cx(
                  'form--element--label-small pl-5',
                  // this.props.parentId === '#block-hero-form'
                  this.props.color === 'white'
                    ? 'color--white'
                    : 'color--grey-5'
                )}>
                {t('i_have_read_and_understood')}{' '}
                <a
                  className="underline"
                  href={getURLWithLang('/privacy-policy/', siteTag, langKey)}
                  target="_blank">
                  {t('privacy_policy')}
                </a>{' '}
                {t('and')}{' '}
                <a
                  className="underline"
                  href={getURLWithLang('/cookies-policy/', siteTag, langKey)}
                  target="_blank">
                  {t('cookie_policy')}
                </a>
              </label>
            </div>

            <Button
              onClick={this.form1Click}
              variant={this.props.color === 'white' ? 'inverse' : 'primary'}
              className={cx(
                this.props.color === 'white' ? 'mt-12' : 'mb-12 mt-8',
                {
                  'mb-0 mt-8 md:mb-24':
                    this.props.parentId === '#contact-right',
                }
              )}>
              {t('submit')}
            </Button>
          </div>

          <div
            className={cx('form-2', {
              'md:pb-14 md:pl-14 md:pt-14 lg:p-16':
                // this.props.parentId === '#block-hero-form',
                this.props.color === 'white',
            })}>
            <p
              className={cx(
                'h3 mb-6',
                // this.props.parentId === '#block-hero-form'
                this.props.color === 'white' ? 'color--white' : 'color--main'
              )}>
              {t('thanks_for_contacting_us')}
            </p>
            <p
              className={cx('mb-3 md:mb-5', {
                'color--white':
                  // this.props.parentId === '#block-hero-form',
                  this.props.color === 'white',
              })}>
              {t('well_reach_out_shortly')}
            </p>
          </div>
        </Section>
      </>
    );
  }
}

export default ContactForm;
